/* eslint-disable sort-imports */
/* eslint-disable new-cap */
import $ from 'jquery';
import ko from 'knockout';
import '../../../../jsscripts/jquery/knockout/knockout.mapping';
import { HTTP_STATUS_NOCONTENT, HTTP_STATUS_OK } from '../../../smartpak/httpstatus';
import cartItemViewModelFactory from './cartitemviewmodelfactory';
import events from '../cart/events';
import shoppingCart from '../api/shoppingcart';

function CartItemsViewModel(model, customerIsSmartPrimeEligible, onUpdateCallback, ShowOneTimeShipSmartPakOption) {
    var mapping = {
        CartItems: {
            create: function (options) {
                return cartItemViewModelFactory(
                    options.data,
                    customerIsSmartPrimeEligible,
                    onUpdateCallback
                );
            }
        }
    };

    ko.mapping.fromJS(model, mapping, this);

    this.canShowEstimatedArrival = ko.observable(true);

    this.currentFocus = ko.observable();

    this.showProp65Warnings = ko.observable(false);

    this.cartMessaging = ko.observable();

    this.hasOneTimeShipSmartPakOption = ShowOneTimeShipSmartPakOption;

    this.isRemovingItem = ko.observable(false);
    this.removeItem = this.removeOrMoveItem(shoppingCart.removeItem, function (cartItem) {
        return cartItem.ItemId();
    });

    this.cartIsEmpty = ko.computed(() => {
        var hasItems = this.CartItems().length === 0;

        if (hasItems) {
            this.cartMessaging('There are no items in your cart');
        }

        return hasItems;
    });

    this.supplyItemsAreAutoShipValid = ko.observable(true);

    this.validateAutoShipSupplyItems = function () {
        var invalidItems = this.CartItems().filter(invalidSupplyAutoShipItem);

        if (invalidItems.length) {
            invalidItems.forEach(function (cartItem) {
                cartItem.validateAutoShip();
            });
        }

        this.supplyItemsAreAutoShipValid(invalidItems.length === 0);
    };

    this.customerFirstName = smartPak.cdProfileCookie.CustomerFirstName;
    this.onUpdateCallback = onUpdateCallback;
    this.customerIsSmartPrimeEligible = customerIsSmartPrimeEligible;

    this.hasSmartPak = function () {
        return this.CartItems().some(function (item) {
            return item.isSmartPak;
        });
    };
}

CartItemsViewModel.prototype.updateCartItems = function (items) {
    this.CartItems(
        ko.utils.arrayMap(
            items,
            function (item) {
                return cartItemViewModelFactory(
                    item,
                    this.customerIsSmartPrimeEligible,
                    this.onUpdateCallback
                );
            }.bind(this)
        )
    );
    $(document).trigger('cartChange');
    this.setFocusOnChange();
};

CartItemsViewModel.prototype.setFocusOnChange = function(){
    const updatedInput = this.currentFocus();

    if(updatedInput){
        document.getElementById(updatedInput)?.focus();
    }
};

CartItemsViewModel.prototype.getCurrentFocus = function (data, event){
    this.currentFocus(event.target.id);
};

CartItemsViewModel.prototype.removeOrMoveItem = function (api, dataFormatter, onSuccess) {
    return cartItem => {
        this.isRemovingItem(true);
        var cartItems = this.CartItems,
            items = cartItems,
            smartPakCartItem,
            smartPakCartItemIndex,
            index;

        if (!cartItem.isSupply) {
            smartPakCartItem = ko.utils.arrayFirst(items(), function (item) {
                return (item.isSmartPak || item.isPortionPak) && item.AccountId() === cartItem.AccountId;
            });

            items = smartPakCartItem.SupplementViewModels;
        }

        index = items.indexOf(cartItem);
        items.remove(cartItem);

        if (!cartItem.isSupply && !items().length) {
            smartPakCartItemIndex = cartItems.indexOf(smartPakCartItem);
            cartItems.remove(smartPakCartItem);
        }

        api(dataFormatter(cartItem)).always(
            function (response) {
                $(document).trigger('cartChange');
                this.isRemovingItem(false);
                if (
                    response.Status !== HTTP_STATUS_NOCONTENT &&
                    response.Status !== HTTP_STATUS_OK
                ) {
                    if (!cartItems.isSupply && !items().length) {
                        cartItems.splice(smartPakCartItemIndex, 0, smartPakCartItem);
                    }

                    items.splice(index, 0, cartItem);
                } else {
                    if ($.isFunction(onSuccess)) {
                        onSuccess(response.Content);
                    }

                    events.removeCartItem({
                        id: cartItem.ProductClassId(),
                        sku: cartItem.ProductId(),
                        quantity: cartItem.Quantity()
                    });

                    this.onUpdateCallback();
                    smartPak.recentlyViewedProducts.loadBvReviewStars('.cartReviewStars');
                }
            }.bind(this)
        );
    };
};

function invalidSupplyAutoShipItem(cartItem) {
    return cartItem.isSupply && !cartItem.isAutoShipValid();
}

export default CartItemsViewModel;